module.exports = __webpack_public_path__ + "img/havefun_title-tc.a5324c81.png";